import { configureStore } from '@reduxjs/toolkit';
import loggedUserReducer from './LoggedUserSlice';

export const store = configureStore({
  reducer: {
    loggedUser: loggedUserReducer,
  },
});

export default store;
